export default "__VITE_ASSET__Du6paLS2__"